<a [routerLink]="['post', id]">
    <div class="card-left">
        <img [src]="imgCardRigth" alt="">
        <span>{{dateCardRigth}}</span>
        <p class="card-decription">{{decriptionCardRigth}}</p>
    </div>
</a>